export default "__VITE_PUBLIC_ASSET__546e3288__"